import { FC, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box, SpeedDial, SpeedDialAction } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import SearchModal from './SearchModal';
import { useActions } from 'src/hooks/useActions';
import { IPanelLinks } from 'src/models/IPanelLinks';

interface IProps {
  links: IPanelLinks[];
}

const PlaygroundSpeedDial: FC<IProps> = ({ links }) => {
  const navigate = useNavigate();
  const { logOut } = useActions();
  const [open, setOpen] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);

  const handleClick = (path: string) => {
    path ? navigate(path) : logOut();
    setOpen(false);
  };

  return (
    <>
      <SpeedDial
        ariaLabel='SpeedDial'
        icon={<MenuIcon />}
        direction={'up'}
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <SpeedDialAction
          key='Search order'
          icon={<SearchIcon />}
          tooltipTitle='Search order'
          onClick={() => setOpenSearch(true)}
        />
        {links.map(action => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={() => handleClick(action.path)}
          />
        ))}
      </SpeedDial>
      <Box
        component='main'
        className={'active'}
        sx={{ margin: '0 0 0 auto', padding: '16px', minHeight: '100vh' }}
      >
        <Outlet />
      </Box>
      <SearchModal handleClose={() => setOpenSearch(false)} open={openSearch} />
    </>
  );
};

export default PlaygroundSpeedDial;
